import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ClassDetailState {
    id: number;
    school: string;
    grade: string;
    code: string;
    name: string;
    school_year: string;
    student_count: string;
    head_teacher_name: string;
    status: 1 | 2;
    created_date: string;
    updated_date: string;
}

interface ClassData {
    classList: ClassDetailState[];
}

const initialState: any = {
    classList: [],
    classCreation: {},
    classModules: [],
    loading: false,
    success: false,
    provinceList: [],
    districtList: [],
    wardList: [],
    schoolList: [],
    schoolListCount:[],
    loadingProvince: false,
    loadingDistrict: false,
    loadingWard: false,
    loadingSchool: false,
    classModuleList: [],
    addLoading: false,
    removeLoading: false,
    loadingDownloadTemplateClass: false,
    templateClassFile: null,
    loadingDownloadImportClassTemplate: false,
    importClassTemplateFile: null,
    loadingImportClassList: false,
    importedClassListPreview: [],
    importClassListSuccess: false,
    classSchoolModuleOptions: [],
    loadingClassSchoolModules: false,
    loadingDeleteClass: false,
    deleteClassSuccess: false,
    loadingFetchClassModules: false,
};

const classSlice = createSlice({
    name: 'class',
    initialState,
    reducers: {
        setLoading(state, action) {
            state.loading = action.payload;
        },
        setSuccess(state, action) {
            state.success = action.payload;
        },
        setClassList(state, action) {
            state.classList = action.payload;
        },
        setClassCreation(state, action) {
            state.classCreation = action.payload;
        },
        setListClassModule(state, action) {
            state.classModules = action.payload;
        },
        clearClassData(state) {
            state.classList = [];
            state.classCreation = {};
            state.classSchoolModuleOptions = [];
        },
        setProvinceList(state, action: PayloadAction<any>) {
            state.provinceList = action.payload?.results
        },
        setDistrictList(state, action: PayloadAction<any>) {
            state.districtList = action.payload
        },
        setWardList(state, action: PayloadAction<any>) {
            state.wardList = action.payload
        },
        setSchoolList(state, action: PayloadAction<any>) {
            state.schoolList = action.payload
        },
        setSchoolCountList(state, action: PayloadAction<any>) {
            state.schoolListCount = action.payload
        },
        setLoadingProvince(state, action: PayloadAction<any>) {
            state.loadingProvince = action.payload
        },
        setLoadingDistrict(state, action: PayloadAction<any>) {
            state.loadingDistrict = action.payload
        },
        setLoadingWard(state, action: PayloadAction<any>) {
            state.loadingWard = action.payload
        },
        setLoadingSchool(state, action: PayloadAction<any>) {
            state.loadingSchool = action.payload
        },
        setClassModuleList(state, action: PayloadAction<any>) {
            state.classModuleList = action.payload
        },
        setClassSchoolModuleOptions(state, action: PayloadAction<any>) {
            state.classSchoolModuleOptions = action.payload;
        },
        setLoadingClassSchoolModules(state, action: PayloadAction<boolean>) {
            state.loadingClassSchoolModules = action.payload;
        },
        setLoadingDeleteClass(state, action: PayloadAction<boolean>) {
            state.loadingDeleteClass = action.payload;
        },
        setDeleteClassSuccess(state, action: PayloadAction<boolean>) {
            state.deleteClassSuccess = action.payload;
        },
        setLoadingFetchClassModules(state, action: PayloadAction<boolean>) {
            state.loadingFetchClassModules = action.payload;
        },
        clearClassSchoolModuleOptions(state) {
            state.classSchoolModuleOptions = [];
        },
        setAddLoading(state, action) {
            state.addLoading = action.payload;
        },
        setRemoveLoading(state, action) {
            state.removeLoading = action.payload;
        },
        setLoadingDownloadTemplateClass(state, action: PayloadAction<any>) {
            state.loadingDownloadTemplateClass = action.payload
        },
        setTemplateClassFile(state, action: PayloadAction<any>) {
            state.templateClassFile = action.payload
        },
        clearTemplateClassFile(state) {
            state.templateClassFile = null
        },
        setLoadingDownloadImportClassTemplate(state, action: PayloadAction<any>) {
            state.loadingDownloadImportClassTemplate = action.payload
        },
        setImportClassTemplateFile(state, action: PayloadAction<any>) {
            state.importClassTemplateFile = action.payload
        },
        clearImportClassTemplateFile(state) {
            state.importClassTemplateFile = null
        },
        setLoadingImportClassList(state, action: PayloadAction<any>) {
            state.loadingImportClassList = action.payload
        },
        setImportedClassListPreview(state, action: PayloadAction<any>) {
            state.importedClassListPreview = action.payload
        },
        setImportClassListSuccess(state, action: PayloadAction<any>) {
            state.importClassListSuccess = action.payload
        },
        clearImportedClassListPreview(state) {
            state.importedClassListPreview = []
            state.importClassListSuccess = false
        },
        clearClassSchoolList(state) {
            state.schoolList = []
        },
        clearClassCreation(state) {
            state.classCreation = {}
        },
        clearClassModuleList(state) {
            state.classModules = []
        }
    },
});

export const {
    setLoading,
    setSuccess,
    setClassList,
    setClassCreation,
    clearClassData,
    setListClassModule,
    setProvinceList,
    setDistrictList,
    setWardList,
    setSchoolList,
    setLoadingProvince,
    setLoadingDistrict,
    setLoadingWard,
    setLoadingSchool,
    setClassModuleList,
    setClassSchoolModuleOptions,
    setLoadingClassSchoolModules,
    setLoadingDeleteClass,
    setDeleteClassSuccess,
    setLoadingFetchClassModules,
    clearClassSchoolModuleOptions,
    setAddLoading,
    setRemoveLoading,
    setLoadingDownloadTemplateClass,
    setTemplateClassFile,
    clearTemplateClassFile,
    setLoadingDownloadImportClassTemplate,
    setImportClassTemplateFile,
    clearImportClassTemplateFile,
    setLoadingImportClassList,
    setImportedClassListPreview,
    setImportClassListSuccess,
    clearImportedClassListPreview,
    clearClassSchoolList,
    setSchoolCountList,
    clearClassCreation,
    clearClassModuleList
} = classSlice.actions;

export default classSlice.reducer;
